/* eslint-disable */
// src/tables/visitStrategies/strategySelector.js

import RentStrategy from "./RentStrategy";
import CashStrategy from "./CashStrategy";
import FichaStrategy from "./FichaStrategy";
import PrizeStrategy from "./PrizeStrategy";
import TragamonedaStrategy from "./TragamonedaStrategy";
import { hasHistoricalRent, hasRent } from "utils/rent";

/* Selecciona la estrategia de UI.  */

export function getVisitTableStrategy(type) {
  switch (type) {
    case "Rockola": return CashStrategy;
    case "Pool":
    case "Tejo":    return FichaStrategy;
    case "Peluchera": return PrizeStrategy;
    case "Tragamoneda": return TragamonedaStrategy;
    default:
      return FichaStrategy;
  }
}

/** 
 * selector por FILA.
 * Si la fila tiene renta (venga en m.Rent o en m.RentPrice), usamos RentStrategy.
 * Si no, elegimos por tipo (del propio item o del fallback `type` recibido).
 */
export function getVisitTableStrategyForItem(m, fallbackType, mode) {
  if (mode === "read" ? hasHistoricalRent(m) : hasRent(m)) return RentStrategy;

  const t = m?.MachineType?.Type || m?.MachineType || fallbackType;
  return getVisitTableStrategy(t);
}

export { default as RentStrategy } from "./RentStrategy";
export { default as CashStrategy } from "./CashStrategy";
export { default as FichaStrategy } from "./FichaStrategy";
export { default as PrizeStrategy } from "./PrizeStrategy";
export { default as TragamonedaStrategy } from "./TragamonedaStrategy";
